import React, { FunctionComponent } from 'react';
import { Link } from 'react-router-dom';

import { css } from '@emotion/react';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import HomeIcon from '@mui/icons-material/Home';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import ManageAccountsOutlinedIcon from '@mui/icons-material/ManageAccountsOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';

import { palette } from '@styles/theme';

/** 네이게이션 메뉴 */
const NAVIGATION_MENUS: any = {
  home: {
    id: 'home',
    label: '홈',
    defaultIcon: <HomeOutlinedIcon />,
    activeIcon: <HomeIcon />,
    href: '/home',
  },
  management: {
    id: 'group',
    label: '조합 관리',
    defaultIcon: <AccountBalanceOutlinedIcon />,
    activeIcon: <AccountBalanceIcon />,
    href: '/group',
  },
  account: {
    id: 'account',
    label: '계정 정보 관리',
    defaultIcon: <ManageAccountsOutlinedIcon />,
    activeIcon: <ManageAccountsIcon />,
    href: '/account',
  },
  report: {
    id: 'report',
    label: '기업보고자료 관리',
    defaultIcon: <ReceiptLongOutlinedIcon />,
    activeIcon: <ReceiptLongIcon />,
    href: '/report',
  },
  groupSetting: {
    id: 'client',
    label: '회사 관리',
    defaultIcon: <AccountBalanceOutlinedIcon />,
    activeIcon: <AccountBalanceIcon />,
    href: '/client',
  },
  accountSetting: {
    id: 'clientAccount',
    label: '회사 계정 관리',
    defaultIcon: <ManageAccountsOutlinedIcon />,
    activeIcon: <ManageAccountsIcon />,
    href: '/client-account',
  },
  partnerManagement: {
    id: 'partnerGroup',
    label: '조합 관리',
    defaultIcon: <AccountBalanceOutlinedIcon />,
    activeIcon: <AccountBalanceIcon />,
    href: '/partner-group',
  },
};

interface MenuProps {
  name: string;
}

export const Menu: FunctionComponent<MenuProps> = ({ name }) => {
  const isPortfolioUrl = location.pathname.startsWith('/portfolio');
  const isActive =
    isPortfolioUrl && NAVIGATION_MENUS[name]?.href === '/group'
      ? true
      : location.pathname.startsWith(NAVIGATION_MENUS[name]?.href);

  return (
    <>
      <li>
        <Link to={NAVIGATION_MENUS[name]?.href}>
          <div css={[menuItem, isActive && menuActive]}>
            {isActive
              ? NAVIGATION_MENUS[name]?.activeIcon
              : NAVIGATION_MENUS[name]?.defaultIcon}
            <span>{NAVIGATION_MENUS[name]?.label}</span>
          </div>
        </Link>
      </li>
    </>
  );
};

const menuItem = css`
  display: flex;
  align-items: center;
  height: 36px;
  gap: 12px;
  padding: 0 10px;
  font-size: 14px;
  cursor: pointer;
  border-radius: 10px;
  span {
    color: ${palette.gray5};
  }

  svg {
    path {
      fill: ${palette.gray5};
    }
  }

  &:hover {
    background-color: ${palette.gray2};
    span {
      color: ${palette.black};
    }

    svg {
      path {
        fill: ${palette.black};
      }
    }
  }
`;

const menuActive = css`
  span {
    color: ${palette.black};
  }
  svg {
    path {
      fill: ${palette.black};
    }
  }
`;
